import { Component } from '@angular/core';

@Component({
    selector: 'app-loading',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class LoadingComponent {}
